module.exports = new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://mais-precoce-sensitivity.alpha.agro.rocks/remoteEntry.js";
        script.onload = () => {
          const module = {
            get: (request) => window["pluginSensitivity"].get(request),
            init: (arg) => {
              try {
                return window["pluginSensitivity"].init(arg);
              } catch (e) {
                console.log("Problem loading remote pluginSensitivity", e);
              }
            },
          };
          resolve(module);
        };
        script.onerror = () => {
  const module = {
    get: () => () => {},
    init: () => () => {},
  };
  resolve(module);
}
        document.head.appendChild(script);
      });